import { useEffect, useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const TONE = {
  warning: { ring: "ring-amber-400/50", chip: "bg-amber-500/15 text-amber-700" },
  positive: { ring: "ring-emerald-400/50", chip: "bg-emerald-500/15 text-emerald-700" },
  info: { ring: "ring-blue-400/40", chip: "bg-blue-500/10 text-blue-700" },
};

export function NeuInsights() {
  const { lang } = useI18n();
  const L = (en, ar) => (lang === "ar" ? ar : en);
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/insights/weekly")
      .then(({ data }) => setItems(data.insights || []))
      .catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="neu-insights" className="neu p-5 h-full">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="w-4 h-4 text-[#c88a06]" strokeWidth={2.4} />
        <p className="font-display font-bold text-sm neu-accent-blue">{L("Weekly Insights", "رؤى الأسبوع")}</p>
      </div>
      {items === null && (
        <div className="flex items-center gap-2 text-xs text-slate-500 py-4">
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
          {L("Analyzing your spending…", "أحلّل إنفاقك…")}
        </div>
      )}
      {items?.length === 0 && (
        <p className="text-xs text-slate-500 py-4">{L("Add more transactions to unlock insights.", "أضف معاملات لتحصل على رؤى.")}</p>
      )}
      <div className="space-y-2">
        {items?.map((i, idx) => {
          const t = TONE[i.severity] || TONE.info;
          return (
            <div key={idx} data-testid={`insight-${idx}`}
                 className={`neu-inset rounded-2xl p-3 ring-1 ${t.ring} flex gap-3`}>
              <div className={`w-9 h-9 rounded-xl grid place-items-center shrink-0 text-lg ${t.chip}`}>{i.emoji}</div>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-sm neu-accent-blue leading-tight">{i.title}</p>
                <p className="text-[11px] text-slate-500 mt-1 leading-snug">{i.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
